var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "base-dropdown",
    class: {
      collapsed: _vm.collapsed
    }
  }, [_c('div', {
    staticClass: "dropdown-container"
  }, [_c('div', {
    ref: "dropdownHeader",
    staticClass: "header",
    attrs: {
      "aria-expanded": !_vm.collapsed,
      "aria-controls": "dropdownmenu",
      "aria-haspopup": "true",
      "aria-label": "Pick the answer dropdown",
      "id": "dropdownbutton",
      "role": "combobox",
      "tabindex": "10"
    },
    on: {
      "click": _vm.onDropDownClick,
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.onDropDownClick($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onDropDownClick($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.onDropDownClick($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.onDropDownClick($event);
      }]
    }
  }, [_c('div', {
    staticClass: "left",
    class: _vm.showIcon ? _vm.isCorrect ? 'correct' : 'wrong' : _vm.isCorrect ? 'correct-disabled' : ''
  }, [_vm.showIcon ? _c('div', {
    staticClass: "feedback-icon-section"
  }, [_c('span', [_vm._v(" ")]), !_vm.isCorrect ? _c('WrongIcon', {
    staticClass: "feedbackIcon",
    attrs: {
      "iconColor": "#FFFFFF"
    }
  }) : _vm.isCorrect ? _c('CorrectIcon', {
    staticClass: "feedbackIcon",
    attrs: {
      "iconColor": "#FFFFFF"
    }
  }) : _vm._e(), _c('span', [_vm._v(" ")])], 1) : _vm.selection ? _c('span', [_vm._v(_vm._s(_vm.selection.value))]) : _c('span', [_vm._v(" ")])]), _vm._m(0)]), _c('div', {
    ref: "dropdownOptionSpacer",
    staticClass: "hidden-option-spacer"
  }, _vm._l(_vm.options, function (option, index) {
    return _c('div', {
      key: index,
      attrs: {
        "tabindex": "-1"
      }
    }, [_c('div', {
      staticClass: "option-spacer"
    }, [_vm._v("\n          " + _vm._s(option.value ? option.value : option) + "\n        ")])]);
  }), 0), !_vm.collapsed ? _c('ul', {
    staticClass: "options-container",
    attrs: {
      "aria-label": "Dropdown Options",
      "id": "dropdownmenu",
      "role": "menu"
    }
  }, _vm._l(_vm.options, function (option, index) {
    return _c('li', {
      key: index,
      staticClass: "option pick-the-answer-dropdown-option",
      class: _vm.selection && _vm.selection.id == option.id || !_vm.selection && option.correct && _vm.numOfAttempts >= 2 ? 'highlighted' : '',
      attrs: {
        "data-index": index,
        "role": "menuitem",
        "tabindex": "0"
      },
      on: {
        "blur": _vm.handleBlur,
        "click": function ($event) {
          return _vm.handleSelection(option);
        },
        "focus": function (e) {
          return _vm.focusedOption = e.target;
        },
        "keyup": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
          return _vm.shiftOptionFocus(_vm.options.length - 1 === index ? index : index + 1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleSelection(option);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return function () {
            return _vm.collapsed = true;
          }($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          return _vm.shiftOptionFocus(index ? index - 1 : index);
        }]
      }
    }, [_vm._v("\n        " + _vm._s(option.value ? option.value : option) + "\n      ")]);
  }), 0) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "arrow-down"
  })]);
}]

export { render, staticRenderFns }